import config from '@config'

const {
  publication: { publication },
} = config

export type UseEnableEnhancedSearchPage = () => boolean

export const getEnhancedSearchPageEnabled = () => publication !== 'romandie'

const useEnableEnhancedSearchPage: UseEnableEnhancedSearchPage = () =>
  publication !== 'romandie'

export default useEnableEnhancedSearchPage
